var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"layout column align-center"},[_c('img',{staticClass:"image",attrs:{"src":_vm.imageSource,"alt":(_vm.imageName + " picture"),"width":_vm.width}})])}
var staticRenderFns = []

export { render, staticRenderFns }